export const CreatUnit = [
  {
    id: "LBIN256347",
    status: "Suspended",
    companyName: "Emayam Technologies",
    email: "contact1@emayam.com",
  },
  {
    id: "LBIN256348",
    status: "Passive",
    companyName: "Zentech Pvt Ltd",
    email: "info@zentech.in",
  },
  {
    id: "LBIN256349",
    status: "Premium",
    companyName: "NeoTech Global",
    email: "support@neotech.com",
  },
];

export const LinkUnit = [
  {
    id: "LBIN256347",
    status: "Suspended",
    companyName: "Emayam Technologies",
    email: "contact1@emayam.com",
  },
  {
    id: "LBIN256348",
    status: "Passive",
    companyName: "Zentech Pvt Ltd",
    email: "info@zentech.in",
  },
  {
    id: "LBIN256349",
    status: "Premium",
    companyName: "NeoTech Global",
    email: "support@neotech.com",
  },
];
